var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    fill: "#053A7A",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 47.5V24.75C54 23.6562 53.3786 23 52.3429 23H31.2143C27.6929 23 25 25.8438 25 29.5625V51.4375C25 55.1562 27.6929 58 31.2143 58H52.3429C53.1714 58 54 57.3438 54 56.25V55.1562C54 54.7188 53.7929 54.2812 53.3786 53.8438C53.1714 52.75 53.1714 49.6875 53.3786 48.8125C53.7929 48.5938 54 48.1562 54 47.5ZM34.3214 32.8438C34.3214 32.2395 34.7849 31.75 35.3571 31.75H38.4643V28.4688C38.4643 27.8645 38.9278 27.375 39.5 27.375H41.5714C42.1437 27.375 42.6071 27.8645 42.6071 28.4688V31.75H45.7143C46.2865 31.75 46.75 32.2395 46.75 32.8438V35.0312C46.75 35.6355 46.2865 36.125 45.7143 36.125H42.6071V43.7812C42.6071 44.3855 42.1437 44.875 41.5714 44.875H39.5C38.9278 44.875 38.4643 44.3855 38.4643 43.7812V36.125H35.3571C34.7849 36.125 34.3214 35.6355 34.3214 35.0312V32.8438ZM49.65 53.625H31.2143C29.9714 53.625 29.1429 52.75 29.1429 51.4375C29.1429 50.125 30.1786 49.25 31.2143 49.25H49.65V53.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.08a91d5694f9c9af2207321e752b64b7.svg";
export { ForwardRef as ReactComponent };